module.exports = __webpack_public_path__ + "efa64cbe30b53fc5be7f43f1e482e256.svg";